module.exports = new __parcel__URL__("easyAgile.6a075018.png").toString();